export const DOCUMENTS_PAGE_SIZE = 10;

export const buildDocumentListUrl = ({
  endpoint,
  baseQuery = "",
  filterQuery = "",
  page = 1,
  size = DOCUMENTS_PAGE_SIZE,
}) => {
  const params = new URLSearchParams(baseQuery);

  new URLSearchParams(filterQuery).forEach((value, key) => {
    params.append(key, value);
  });

  params.set("page", String(page));
  params.set("size", String(size));

  return `${process.env.REACT_APP_BACKEND_URL}${endpoint}?${params.toString()}`;
};

export const sortDocumentsByDynamicDate = (documents) =>
  [...documents].sort(
    (firstDocument, secondDocument) =>
      new Date(firstDocument.fechaDinamica) - new Date(secondDocument.fechaDinamica)
  );
